import imagePreview from '../modules/image-preview';

const initialize = () => {
    $('#logoInput').on('change', function() {
        if (!this.files || !this.files[0]) {
            return;
        }

        let imagePreviewInstance = new imagePreview();
        imagePreviewInstance.preview(this.files[0], function(imagePath) {
            if (imagePath) {
                let imageElement = $('#image');

                if (!imageElement.length) {
                    imageElement = $('<img id="image" class="logo">').appendTo('#domain-logo-image');
                }

                imageElement.attr('src', imagePath);
            }
        });
    });
};

export default initialize;
